// "Needs attention" — alerts computed from real signals (alerts.js).

import { useMemo } from 'react';
import { Card, Eyebrow, Dot } from '../ui';
import { computeAlerts } from './alerts';

const TONE = {
  warn: { bg: 'bg-amber/10', dot: '#B7791F' },
  crit: { bg: 'bg-rose/10', dot: '#FF6E83' },
  ok: { bg: 'bg-deep-teal/10', dot: '#006D78' },
};

export default function AlertsCard({ entries, gsc, ac, pace }) {
  const alerts = useMemo(() => computeAlerts({ entries, gsc, ac, pace }), [entries, gsc, ac, pace]);

  return (
    <Card lash="rose" className="p-4 flex-1">
      <Eyebrow className="mb-3">Needs attention</Eyebrow>
      <div className="flex flex-col gap-2">
        {alerts.map((a, i) => (
          <div key={i} className={`flex items-start gap-2.5 px-3 py-2 rounded-[7px] text-[12.5px] ${TONE[a.tone].bg}`}>
            <Dot color={TONE[a.tone].dot} className="mt-[5px]" />
            <div className="text-ink">
              <b className="text-navy">{a.title}</b> {a.body}
            </div>
          </div>
        ))}
      </div>
    </Card>
  );
}
